import { useSelector } from 'react-redux';

import { selectApplication } from '../../store/selectors/applicationSelectors';
import { APPLICATION_TYPE } from '../constants';
import { APPLICATION_ADDRESS } from '../gtmEvents';
import useGtmHook from './useGtmHook';

const useGtmAddressDoneHook = () => {
  const { gtmEvent } = useGtmHook();

  const Application = useSelector(selectApplication);

  const { ApplicationType } = Application;

  const gtmAddressDoneHook = () => {
    gtmEvent(APPLICATION_ADDRESS, {
      event_label: 'registration',
      application_type: APPLICATION_TYPE[ApplicationType],
    });
  };

  return { gtmAddressDoneHook };
};

export default useGtmAddressDoneHook;
